<script setup lang="ts">
import type { ProductAliases } from '~/config'

interface Props {
  visible: boolean
  productCode: ProductAliases
}

defineProps<Props>()
const emits = defineEmits(['close'])
</script>

<template>
  <PvDialog
    :visible
    :closable="false"
    modal
    class="max-w-[90%] md:w-[75rem]"
  >
    <ContentProductSumary :product-code>
      <template #action>
        <PvButton
          class="place-self-end self-start"
          text
          @click="emits('close')"
        >
          <span class="icon-[ph--x-circle-bold] text-4xl text-current" />
        </PvButton>
      </template>
    </ContentProductSumary>
  </PvDialog>
</template>
